import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  object-fit: contain;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex !important;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  outline: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  .slick-arrow {\n    position: absolute;\n    top: ", ";\n    bottom: ", ";\n    width: ", ";\n    height: ", ";\n    border: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: 1;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n\n    &.slick-prev {\n      left: ", ";\n      right: ", ";\n      background-image: url(", ");\n    }\n\n    &.slick-next {\n      left: ", ";\n      right: ", ";\n      background-image: url(", ");\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: ", ";\n  right: ", ";\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  z-index: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: ", ";\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect } from 'react';
import Slick from 'react-slick';
import styled from 'styled-components';
import { layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import 'slick-carousel/slick/slick.css';
import { Portal } from '../portal/Portal';
import { Icon } from '../icon/Icon';
import { Button } from '../button/Button';
import { Box } from '../grid/Grid';
import next from './next.svg';
import prev from './prev.svg';
var Mask = styled.div(_templateObject(), themeGet('zIndex.modalMask'), themeGet('colors.blacks.2'));
var CloseButton = styled(Button).attrs({
  variant: 'link'
})(_templateObject2(), themeGet('lightbox.closeButton.top'), themeGet('lightbox.closeButton.right'), themeGet('lightbox.closeButton.size'), themeGet('lightbox.closeButton.size'), themeGet('lightbox.closeButton.backgroundColor'), themeGet('lightbox.closeButton.borderRadius'), themeGet('zIndex.fixed'));
var StyledSlick = styled(Slick)(_templateObject3(), themeGet('lightbox.arrow.top'), themeGet('lightbox.arrow.bottom'), themeGet('lightbox.arrow.width'), themeGet('lightbox.arrow.height'), themeGet('lightbox.arrow.border'), themeGet('lightbox.arrow.borderRadius'), themeGet('lightbox.arrow.backgroundColor'), themeGet('lightbox.arrow.prev.left'), themeGet('lightbox.arrow.prev.right'), prev, themeGet('lightbox.arrow.next.left'), themeGet('lightbox.arrow.next.right'), next);
var Slide = styled.div(_templateObject4());
var SlideImage = styled.img.attrs(function (props) {
  return {
    maxWidth: ['none', themeGet('lightbox.slideImage.desktopMaxWidth')(props)],
    maxHeight: ['none', themeGet('lightbox.slideImage.desktopMaxHeight')(props)]
  };
})(_templateObject5(), layout);
var settings = {
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 1,
  arrows: true,
  prevArrow:
  /*#__PURE__*/
  React.createElement(Box, {
    display: ['none !important', 'inline-block !important']
  }),
  nextArrow:
  /*#__PURE__*/
  React.createElement(Box, {
    display: ['none !important', 'inline-block !important']
  })
};
export var Lightbox = function Lightbox(_ref) {
  var images = _ref.images,
      currentIndex = _ref.currentIndex,
      show = _ref.show,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["images", "currentIndex", "show", "onClose"]);

  useEffect(function () {
    show ? disableBodyScroll() : clearAllBodyScrollLocks();
  }, [show]);
  return show &&
  /*#__PURE__*/
  React.createElement(Portal, null,
  /*#__PURE__*/
  React.createElement(Mask, null,
  /*#__PURE__*/
  React.createElement(CloseButton, {
    onClick: onClose
  },
  /*#__PURE__*/
  React.createElement(Icon, {
    name: "close",
    fontSize: 16,
    color: "white"
  })),
  /*#__PURE__*/
  React.createElement(StyledSlick, _extends({
    initialSlide: currentIndex
  }, settings, props), images.map(function (item, index) {
    return (
      /*#__PURE__*/
      React.createElement(Slide, {
        key: "slide-".concat(index)
      },
      /*#__PURE__*/
      React.createElement(SlideImage, {
        src: item.src,
        alt: item.alt
      }))
    );
  }))));
};